/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Jgu8Inputs */

const en__field_enum_icsrm_jgu8 = /** @type {(inputs: _Field_Enum_Icsrm_Jgu8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg University Mainz`)
};

const de__field_enum_icsrm_jgu8 = /** @type {(inputs: _Field_Enum_Icsrm_Jgu8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg-Universität Mainz`)
};

/**
* | output |
* | --- |
* | "Johannes Gutenberg University Mainz" |
*
* @param {_Field_Enum_Icsrm_Jgu8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_jgu8 = /** @type {((inputs?: _Field_Enum_Icsrm_Jgu8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Jgu8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_jgu8(inputs)
	return de__field_enum_icsrm_jgu8(inputs)
});
export { _field_enum_icsrm_jgu8 as "_field_enum_ICSRM_JGU" }